import { msalInstance } from "../msalConfig";
import { refreshToken } from "../actions/authActions";

const tokenMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type === "MSAL_INSTANCE") {
      // Initialize MSAL instance
      msalInstance
        .initialize()
        .then(() => {
          // Check token expiration before every API call
          if (msalInstance.getAllAccounts().length) {
            msalInstance
              .acquireTokenSilent({
                scopes: [
                  `${process.env.REACT_APP_READ}`,
                  `${process.env.REACT_APP_WRITE}`,
                ],
              })
              .then((response) => {
                // Successfully refreshed token
                // Update localStorage or dispatch an action to update Redux state with the new token
                localStorage.setItem("token", response.idToken);
                next(action);
              })
              .catch((error) => {
                console.error("Error refreshing token:", error);
                // Failed to refresh token, perform appropriate action (e.g., logout)
                dispatch(refreshToken());
              });
          } else {
            // No user signed in, perform appropriate action (e.g., redirect to login page)
          }
        })
        .catch((error) => {
          console.error("Error initializing MSAL instance:", error);
        });
    } else {
      return next(action);
    }
  };

export default tokenMiddleware;
